import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { QrCodeGeneratorPage } from './pages/qr-code-generator/qr-code-generator.page';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(
      m => m.DashboardPageModule
    ), canActivate: [AuthGuard]
  },
  { path: 'dashboard', redirectTo: '' },
  {
    path: 'login',
    loadChildren: () => import('./pages/sessions/login/login.module').then(
      m => m.LoginPageModule
    ), canActivate: [LoginGuard]
  },
  {
    path: 'loaded-init',
    loadChildren: () => import('./pages/sessions/loader-init/loader-init.module').then(
      m => m.LoaderInitPageModule
    ), canActivate: [LoginGuard]
  },
  {
    path: 'user-index',
    loadChildren: () => import('./pages/users/user-index/user-index.module').then(
      m => m.UserIndexPageModule
    )
  },
  {
    path: 'notification-index',
    loadChildren: () => import('./pages/message/notifications/notification-index/notification-index.module').then(
      m => m.NotificationIndexPageModule
    )
  },
  {
    path: 'notifications-form',
    loadChildren: () => import('./pages/message/notifications/notifications-form/notifications-form.module').then(
      m => m.NotificationsFormPageModule
    )
  },
  {
    path: 'notifications-edit',
    loadChildren: () => import('./pages/message/notifications/notifications-edit/notifications-edit.module').then(
      m => m.NotificationsEditPageModule
    )
  },
  {
    path: 'user-edit',
    loadChildren: () => import('./pages/users/user-edit/user-edit.module').then(
      m => m.UserEditPageModule
    )
  },
  {
    path: 'user-new',
    loadChildren: () => import('./pages/users/user-new/user-new.module').then(m => m.UserNewPageModule)
  },
  {
    path: 'exercises-index',
    loadChildren: () => import('./pages/exercises/exercises-index/exercises-index.module').then(m => m.ExercisesIndexPageModule)
  },
  {
    path: 'exercises-form',
    loadChildren: () => import('./pages/exercises/exercises-form/exercises-form.module').then(m => m.ExercisesFormPageModule)
  },
  {
    path: 'car',
    loadChildren: () => import('./pages/shop/car/car.module').then(m => m.CarPageModule)
  },
  {
    path: 'automatic-charge',
    loadChildren: () => import('./pages/automatic-chargev2/automatic-chargev2.module').then(m => m.AutomaticChargev2PageModule)
  },
  // {
  //   path: 'wod-videos-new',
  //   loadChildren: () => import('./pages/wodVideos/wod-videos-new/wod-videos-new.module').then(m => m.WodVideosNewPageModule)
  // },
  // {
  //   path: 'wod-videos/videos',
  //   loadChildren: () => import('./pages/wodVideos/wod-videos.module').then(m => m.WodVideosModule)
  // },
  {
    path: 'routines',
    loadChildren: () => import('./pages/routine/routine.module').then(m => m.RoutineModule),
  },
  {
    path: 'muro-index',
    loadChildren: () => import('./pages/muro/muro-index/muro-index.module').then(m => m.MuroIndexPageModule)
  },
  {
    path: 'muro-form',
    loadChildren: () => import('./pages/muro/muro-form/muro-form.module').then(m => m.MuroFormPageModule)
  },
  {
    path: 'muro-new',
    loadChildren: () => import('./pages/muro/muro-new/muro-new.module').then(m => m.MuroNewPageModule)
  },
  {
    path: 'muro-edit',
    loadChildren: () => import('./pages/muro/muro-edit/muro-edit.module').then(m => m.MuroEditPageModule)
  },
  {
    path: 'temas',
    loadChildren: () => import('./pages/muro/temas/temas.module').then(m => m.TemasPageModule)
  },
  // {

  //   path: 'wod-videos-form',
  //   loadChildren: () => import('./pages/wodVideos/wod-videos-form/wod-videos-form.module').then(m => m.WodVideosFormPageModule)
  // },
  {
    path: 'purchases',
    loadChildren: () => import('./pages/shop/purchases/purchases.module').then(m => m.PurchasesPageModule)
  },
  {
    path: 'divisas',
    loadChildren: () => import('./pages/divisas/divisas.module').then(m => m.DivisasPageModule)
  },
  {
    path: 'chargesOnly',
    loadChildren: () => import('./pages/automatic-chargev2/automatic-chargev2.module')
      .then(m => m.AutomaticChargev2PageModule)
  },
  {
    path: 'pre-registers',
    loadChildren: () => import('./pages/pre-registers/pre-registers.module').then(m => m.PreRegistersPageModule)
  },
  {
    path: 'fast-list',
    loadChildren: () => import('./pages/routine/fast/fast-list/fast-list.module').then(m => m.FastListPageModule)
  },
  {
    path: 'fast-new',
    loadChildren: () => import('./pages/routine/fast/fast-new/fast-new.module').then(m => m.FastNewPageModule)
  },
  {
    path: 'fast-edit',
    loadChildren: () => import('./pages/routine/fast/fast-edit/fast-edit.module').then(m => m.FastEditPageModule)
  },
  {
    path: 'fast-form',
    loadChildren: () => import('./pages/routine/fast/fast-form/fast-form.module').then(m => m.FastFormPageModule)
  },
  {
    path: 'coach-index',
    loadChildren: () => import('./pages/routine/coach/coach-index/coach-index.module').then(m => m.CoachIndexPageModule)
  },
  {
    path: 'coach-groups-new',
    loadChildren: () => import('./pages/routine/coach/coach-groups/coach-groups-new/coach-groups-new.module').then(m => m.CoachGroupsNewPageModule)
  },
  {
    path: 'coach-groups-edit',
    loadChildren: () => import('./pages/routine/coach/coach-groups/coach-groups-edit/coach-groups-edit.module').then(m => m.CoachGroupsEditPageModule)
  },
  {
    path: 'coach-groups-form',
    loadChildren: () => import('./pages/routine/coach/coach-groups/coach-groups-form/coach-groups-form.module').then(m => m.CoachGroupsFormPageModule)
  },
  {
    path: 'coach-edit',
    loadChildren: () => import('./pages/routine/coach/coach-edit/coach-edit.module').then(m => m.CoachEditPageModule)
  },
  {
    path: 'coach-add-users',
    loadChildren: () => import('./pages/routine/coach/coach-add-users/coach-add-users.module').then(m => m.CoachAddUsersPageModule)
  },
  {
    path: 'qr-code-generator-articles',
    loadChildren: () => import('./pages/qr-code-generator-articles/qr-code-generator-articles.module').then( m => m.QrCodeGeneratorArticlesPageModule)
  },
  {
    path: 'qr-code',
    component: QrCodeGeneratorPage
  },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
